// components/SearchHeader.js
import {Input} from "antd";
import {memo} from "react";

export const SearchHeader = memo(({value, onChange}) => (
    <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
        <Input
            placeholder="Наименование..."
            value={value}
            onChange={e => onChange(e.target.value)}
            onClick={e => e.stopPropagation()}
            style={{width: '100%', fontSize: '12px'}}
            allowClear
        />
    </div>
));

SearchHeader.displayName = 'SearchHeader';